// extracted by mini-css-extract-plugin
export default {"root":"SecurePaymentBadge_root__tV5uB","icon":"SecurePaymentBadge_icon__XUJLV","title":"SecurePaymentBadge_title__9yR1w","text":"SecurePaymentBadge_text__no1KA"};